/* StageCardVideoPreview.tsx */
import React from "react";
import { Box, Typography } from "@mui/material";
import {
  isYouTubeUrl,
  getYouTubeEmbedUrl,
} from "../../../utils/helper";                 // keep your helper paths
import { StageCardFormValues } from "@/types/Card"; // keep your types paths

type Props = {
  values: StageCardFormValues;
};

const StageCardVideoPreview: React.FC<Props> = ({ values }) => {
  const url = values.previewVideoUrl || "";               // new camelCase field
  const embedUrl = isYouTubeUrl(url) ? getYouTubeEmbedUrl(url) : null;

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography sx={{ color: "var(--neutral-1000)", font: "var(--h6)", mb: 2 }}>
        Video Preview
      </Typography>

      {embedUrl ? (
        <Box
          component="iframe"
          src={embedUrl}
          width="100%"
          height="432px"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sx={{ borderRadius: 2 }}
        />
      ) : url ? (
        <Box
          component="video"
          src={url}
          controls
          width="100%"
          height="432px"
          sx={{ borderRadius: 2 }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No preview video uploaded.
        </Typography>
      )}
    </Box>
  );
};

export default StageCardVideoPreview;
